import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { CashbackModule } from '@features/cashback/cashback.module';
import { OrderModule } from '@features/order/order.module';
import { PollingModule } from '@features/polling/polling.module';
import { PromocodeModule } from '@features/promocode/promocode.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PopupModule } from '@rd/popup/popup.module';
import { CounterComponent } from '@rd/shared-legacy/components/counter/counter.component';
import { SharedSuccessButtonsComponent } from '@rd/shared-legacy/components/success-buttons/success-buttons.component';
import { DataTestidDirective } from '@rd/shared-legacy/directives/data-testid/data-testid.directive';
import { SharedModule } from '@rd/shared-legacy/shared.module';
import { PromocodeUiComponent } from '@rd/shared-legacy/widgets/promocode-ui/promocode-ui.component';
import { RcV2CheckoutBannerWrapperComponent } from './components/checkout-banner/checkout-banner-wrapper.component';
import { RcV2CheckoutBannerComponent } from './components/checkout-banner/checkout-banner.component';
import { RcV2CheckoutFormWrapperComponent } from './components/checkout-form/checkout-form-wrapper.component';
import { RcV2CheckoutFormComponent } from './components/checkout-form/checkout-form.component';
import { RcV2CheckoutInformationComponent } from './components/checkout-information/checkout-information.component';
import { RcV2CheckoutLinkedAccountComponent } from './components/checkout-linked-account/checkout-linked-account.component';
import { RcV2CheckoutTermsListComponent } from './components/checkout-terms-list/checkout-terms-list.component';
import { RcV2CheckoutTransferAmountFormComponent } from './components/checkout-transfer-amount-form/checkout-transfer-amount-form.component';
import { RcV2LinkAccountDetailFormComponent } from './components/link-account-detail-form/link-account-detail-form.component';
import { RcV2LinkAccountFormComponent } from './components/link-account-form/link-account-form.component';
import { RcV2MembershipFailedDialogComponent } from './components/membership-failed-dialog/membership-failed-dialog.component';
import { RcV2MembershipSuccessDialogComponent } from './components/membership-success-dialog/membership-success-dialog.component';
import { RcV2ReviewBodyComponent } from './components/review-body/review-body.component';
import { RcV2ReviewBreakdownComponent } from './components/review-breakdown/review-breakdown.component';
import { RcV2ReviewFormComponent } from './components/review-form/review-form.component';
import { RcV2SuccessDetailComponent } from './components/success-detail/success-detail.component';
import { RcV2SuccessPointsTransactionStatusComponent } from './components/success-points-transaction-status/success-points-transaction-status.component';
import { RcV2CheckoutLinkAccountDialogComponent } from './containers/checkout-link-account-dialog/checkout-link-account-dialog.component';
import { FormDataGuard } from './guards/form-data.guard';
import { RedeemCashSettingService } from './services/redeem-cash-setting/redeem-cash-setting.service';
import { CheckoutEffects } from './store/effects/checkout.effects';
import { EnrollmentEffects } from './store/effects/enrollment.effects';
import { MembershipEffects } from './store/effects/membership.effects';
import { RedeemCashLoyaltyProgramEffects } from './store/effects/redeem-cash-loyalty-program.effects';
import { reducers } from './store/reducers/index';
import { RcV2CheckoutComponent } from './views/checkout/checkout.component';
import { RcV2ReviewComponent } from './views/review/review.component';
import { RcV2SuccessComponent } from './views/success/success.component';

const declaredComponents: any[] = [
  RcV2CheckoutLinkAccountDialogComponent,
  RcV2CheckoutBannerComponent,
  RcV2CheckoutBannerWrapperComponent,
  RcV2CheckoutFormComponent,
  RcV2CheckoutFormWrapperComponent,
  RcV2CheckoutInformationComponent,
  RcV2CheckoutLinkedAccountComponent,
  RcV2CheckoutTermsListComponent,
  RcV2CheckoutTransferAmountFormComponent,
  RcV2LinkAccountDetailFormComponent,
  RcV2LinkAccountFormComponent,
  RcV2MembershipFailedDialogComponent,
  RcV2MembershipSuccessDialogComponent,
  RcV2ReviewBodyComponent,
  RcV2ReviewBreakdownComponent,
  RcV2ReviewFormComponent,
  RcV2SuccessDetailComponent,
  RcV2SuccessPointsTransactionStatusComponent,
];

const exportComponents: any[] = [
  RcV2CheckoutBannerComponent,
  RcV2CheckoutBannerWrapperComponent,
  RcV2CheckoutFormComponent,
  RcV2CheckoutFormWrapperComponent,
  RcV2CheckoutInformationComponent,
  RcV2LinkAccountDetailFormComponent,
  RcV2LinkAccountFormComponent,
  RcV2CheckoutLinkedAccountComponent,
  RcV2CheckoutTermsListComponent,
  RcV2CheckoutTransferAmountFormComponent,
];

const views = [
  RcV2CheckoutComponent,
  RcV2ReviewComponent,
  RcV2SuccessComponent,
];

@NgModule({
  declarations: [...declaredComponents, ...views],
  imports: [
    CommonModule,
    SharedSuccessButtonsComponent,
    DataTestidDirective,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    SharedModule,
    RouterModule,
    PromocodeUiComponent,
    StoreModule.forFeature('redeemCashV2', reducers),
    EffectsModule.forFeature([
      CheckoutEffects,
      EnrollmentEffects,
      RedeemCashLoyaltyProgramEffects,
      MembershipEffects,
    ]),
    PopupModule,
    PromocodeModule,
    OrderModule,
    PollingModule,
    CashbackModule,
    CounterComponent,
  ],
  providers: [FormDataGuard, RedeemCashSettingService],
  exports: [SharedModule, ...exportComponents],
})
export class RedeemCashV2Module {}
